module.exports = __webpack_public_path__ + "img/en_US.d163dcb.jpg";